// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__VHdyC","title":"Info_title__8LMW6","links":"Info_links__2SDKF","link":"Info_link__PMvaC","logo":"Info_logo__1vEvN"};